import { useAuth0 } from '@auth0/auth0-react'
import config from '../../config'
import { useQuery } from 'react-query'
import { get } from 'lodash'
import useCacheKeys from '../use-cache-keys'
import useStaleTimes from '../use-stale-times'
import useApi from '../use-api'

const accessTokenConfig = {
    audience: config.authAudience,
    scope: 'read:current_user',
}

const useToken = () => {
    const cacheKeys = useCacheKeys()
    const staleTimes = useStaleTimes()
    const { setAuthorizationToken } = useApi()

    //  We need to know the state of auth0
    const { user, isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0()

    //  Configure useQuery
    const {
        data,
        isLoading: isLoadingToken
    } = useQuery(
        [cacheKeys.AUTH, get(user, 'sub')],
        () => getAccessTokenSilently(accessTokenConfig),
        {
            enabled: Boolean(user) && !isLoading && isAuthenticated,
            onSuccess: token => setAuthorizationToken(`Bearer ${token}`),
            staleTime: staleTimes.MINUTE
        }
    )

    return {
        token: data,
        isBusy: isLoading || isLoadingToken
    }
}

export default useToken
